import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
import { Tool } from "@/types/tools";
import { cn } from "@/lib/utils";

interface ToolCardProps {
  tool: Tool;
  onLaunch: (path: string) => void;
}

export function ToolCard({ tool, onLaunch }: ToolCardProps) {
  // Determine button label and state
  const buttonLabel = tool.comingSoon ? "Coming Soon" : "Launch Tool";

  return (
    <Card
      className={cn(
        "relative overflow-hidden transition-all duration-300",
        "hover:shadow-lg hover:-translate-y-1"
      )}
    >
      {/* Header Section */}
      <CardHeader>
        <div className="flex items-center gap-3 mb-2">
          <tool.icon className={cn("h-6 w-6 flex-shrink-0", tool.color)} />
          <CardTitle>{tool.title}</CardTitle>
        </div>
        <CardDescription>{tool.description}</CardDescription>
      </CardHeader>

      {/* Content Section */}
      <CardContent>
        <Button
          onClick={() => onLaunch(tool.path)}
          disabled={tool.comingSoon}
          aria-disabled={tool.comingSoon}
          aria-label={tool.comingSoon ? `${tool.title} is coming soon` : `Launch ${tool.title}`}
          className="w-full transition-all hover:translate-x-1"
        >
          {tool.comingSoon ? (
            buttonLabel
          ) : (
            <>
              {buttonLabel}
              <ArrowRight className="ml-2 h-4 w-4" />
            </>
          )}
        </Button>
      </CardContent>
    </Card>
  );
}
